import {createAction, createAsyncThunk} from '@reduxjs/toolkit';

import {getItemTypes} from '@explorer/api/items';

export const selectItemTypes = createAction('SELECT_ITEM_TYPES');
export const resetSelectedItemTypes = createAction('RESET_SELECTED_ITEM_TYPES');

export const fetchItemTypes = createAsyncThunk('itemTypes/fetch', () =>
  getItemTypes()
);
